<template>
    <div class="box" ref="container">
        <div class="content">
            <div class="leftContent">
                <div class="ListContent">
                    <Essential v-if="list !== ''" :list="list" />
                </div>
            </div>

            <div class="rightContent">
                <div class="banes">
                    <div class="item" @click="goUrl('/Home/FirstPage')">
                        <img src="./images/11.png" alt="" />
                    </div>
                    <div class="item" @click="goUrl('/Home/ZhanJiaList')">
                        <img src="./images/22.png" alt="" />
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import Essential from "@/components/essential";
import { Getprofessiondetails } from "@/api/Occupation";

export default {
    name: "SearchUniversityIndex",
    components: { Essential },
    data() {
        return {
            tabsIndex: 0,
            listObj: {
                id: '',
            },
            list: '',
        };
    },

    mounted() {
        console.log(this.$route.query.id);
        if (this.$route.query.id !== undefined) {
            this.listObj.id = this.$route.query.id;
            this.getList()
        }
    },

    methods: {
        goUrl(url) {
            this.$router.push(url);
        },
        async getList() {
            const res = await Getprofessiondetails({
                ...this.listObj
            })
            this.list = res.data.result
        },
    },
};
</script>

<style lang="less" scoped>
img {
    width: 100%;
    height: 100%;
}

.box {
    margin: 0 auto;
    min-height: 100vh;
    background: #ffffff;
}



.content {
    display: flex;
    width: 1280px;
    margin: 0 auto;
}

.leftContent {
    flex: 1;
    min-width: 956px;
    margin-right: 16px;

    .ListContent {
        padding-top: 56px;

        .ListItemTitle {
            display: flex;
            align-items: center;
            margin-bottom: 32px;

            .Zy {
                font-weight: 600;
                font-size: 20px;
                margin-right: 16px;
            }

            .Js {
                font-size: 14px;
                color: #86909c;
            }
        }

        .ListItemList {
            margin-bottom: 42px;

            .ListItemItem {
                display: flex;
                align-items: top;

                .Dl {
                    margin-right: 104px;
                    font-size: 16px;
                    font-weight: 600;
                    width: 96px;
                }

                .right {
                    flex: 1;
                    display: flex;
                    flex-wrap: wrap;
                    font-size: 16px;

                    .Xl {
                        cursor: pointer;
                        width: 25%;
                        margin-bottom: 16px;
                    }

                    .Xl:hover {
                        color: #187cff;
                    }
                }
            }
        }
    }
}

.rightContent {
    width: 308px;
    overflow: hidden;
    float: left;

    .banes {
        width: 100%;

        .item {
            cursor: pointer;
            width: 308px;
            height: 154px;
            margin-bottom: 20px;

            img {
                width: 100%;
                height: 100%;
            }
        }
    }

    .articleCont_right_zhengce {
        width: 100%;
        background: #fff;
        border-radius: 8px 8px 8px 8px;
        box-sizing: border-box;
        border: 1px solid #EEEEEE;
        padding: 24px 20px;

        .title {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 24px;

            .tit {
                font-weight: 600;
                font-size: 20px;
            }

        }

        .school-box {
            margin-top: 38px;

            div,
            .school-box .school-item {
                display: flex;
                align-items: center;
            }

            .school-item:hover .type {
                color: #187cff !important;
            }

            .school-item {
                margin-bottom: 24px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                cursor: pointer;

                .schoolName {
                    font-size: 14px;
                    display: flex;

                    .type {
                        margin-left: 10px;
                    }
                }

                .Rd {
                    font-size: 14px;
                    color: #888;
                }
            }
        }

        .policy_title:hover {
            color: #187cff !important;
            cursor: pointer;
        }
    }
}

// ------loading样式---------
.loading_wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #999;
    padding: 20px 0;

    .loading {
        box-sizing: border-box;
        width: 20px;
        height: 20px;
        border: 2px solid #ddd;
        border-radius: 50%;
        animation: rotate 1s linear infinite;
        margin-right: 10px;
    }

    .container {
        position: relative;
        top: 50%;
        left: 50%;
        width: 10px;
        height: 10px;
        background-color: #fff;
    }
}

/*------loading动画---------*/
@keyframes rotate {
    from {
        transform-origin: center center;
        transform: rotate(0deg);
    }

    to {
        transform-origin: center center;
        transform: rotate(360deg);
    }
}
</style>
